$(document).ready(function () {

    $('.serviceManagerInformation .owl-carousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        responsive: {
            0: {
                items: 1
            }
        }
    });

    if ($('#timeline').length > 0) {
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > ($(document).height() * 0.75)) {
                fetchMessages();
            }
        });
        const urlParams = new URLSearchParams(window.location.search);
        const getParams = urlParams.has('search') ? { search: urlParams.get('search') } : undefined;
        var loadingMessages = false;
        function fetchMessages() {
            if (loadingMessages === false) {
                loadingMessages = true;
                $.ajax({
                    type: "POST",
                    url: Routing.generate('timeline_messages', getParams),
                    data: { offset: $('#timeline').data("number-of-messages") },
                })
                    .done(function (data) {
                        if (data.message.length > 0) {
                            $('#messageBoard').append(data.message);
                            $('.timelineImage').materialbox();
                            $('.singleImage').materialbox();
                            $('#timeline').data("number-of-messages", JSON.parse(data.offset));
                            addReplySubmitFunction();
                            addMessageEditFunction();
                            addReportMessageFunction();
                            initMoreLess();
                            loadingMessages = false;
                            addPollPrevQuestionFunction(); // function from poll.js
                            addPollNextQuestionFunction(); // function from poll.js
                            addPollSubmitQuestionFunction(); // function from poll.js
                            addPollSubmitFunction(); // function from poll.js
                        } else {
                            $('#noMoreMessages').show();
                        }
                    });
            }
        }
    }
    if ($('#timelineSegment').length > 0) {
        addReplySubmitFunction();
        addMessageEditFunction();
        addDeleteImageConfirmationModalFunction();
        addReportMessageFunction();
        addReportMessageConfirmationModalFunction();
    }

    $('#timelineSegment').on("focus", 'form[name="timeline_message"] .input-field > textarea', function () {
        $(".sendButton,.menuIcon,.replyForm .input-field,.replyForm .replyButtons").removeClass('active');
        $(this).parent().parent().find(".sendButton").addClass('active');
        $(this).parent().parent().find(".menuIcon").addClass('active');
        $(this).parent().parent().find(".input-field").addClass('active');
        $(this).parent().parent().find(".replyButtons").addClass('active');


    });

    $('#timelineSegment').on("input", 'form[name="timeline_message"] .input-field > textarea', function () {
        if ($(this).val().length >= 1) {
            $(this).parent().parent().find(".sendButton").addClass('bold');
        } else {
            $(this).parent().parent().find(".sendButton").removeClass('bold');
        }
    });

    $('#timelineSegment').on("focusout", 'form[name="timeline_message"] .input-field > textarea', function () {
        if ($('form[name="timeline_message"] .input-field > textarea').val().length < 1) {
            $(".sendButton,.menuIcon,.replyForm .input-field,.replyForm .replyButtons").removeClass('active');
        }
    });

    $('.timelineContainer .formContainer form[name=timeline_message] textarea').on("focus", function () {
        $(this).addClass('minHeight');
    });
    $('.timelineContainer .formContainer form[name=timeline_message] textarea').on("focusout", function () {
        if ($('.timelineContainer .formContainer form[name=timeline_message] textarea').val().length < 1) {
            $(this).removeClass('minHeight');
        }
    });


    $('#messageBoard .formContainer form[name=timeline_message] textarea').on("focus", function () {
        if($(this).parent().hasClass('input-field')){
            var curHeight = $(this).parent().height();
            $(this).parent().css('height','auto');

            var oldHeight = $(this).parent().height();
            var parent = $(this).parent();
            $(this).parent().height(curHeight).animate(
            {
                height: oldHeight
            }, 100, function(){
                parent.height('auto');
            });
        }
    });
    $('#messageBoard .formContainer form[name=timeline_message] textarea').on("focusout", function () {
        if ($(this).val().length < 1) {
            if($(this).parent().hasClass('input-field')){
                if($(this).val() == ""){
                    $(this).parent().height($(this).parent().height()).animate({height: '40px'}, 100);
                }
            }
        }
    });


    $('#timelineSegment').on("click", '.replyButtons .menuIcon', function () {
        $('#' + $(this).data('form') + ' .mediaUploadSection').show()
    });

    $('#timelineSegment').on("submit", 'form[name="timeline_message"]', function () {
        $(this).find('.loadIcon').show();
    });

    $('#modalConfirmMessage').modal({
        dismissible: false,
    });

    var hasConfirmed = false;

    if ($('#modalConfirmMessage').length) {
        $('#timeLineMessage').on("submit", function(e) {
            if (!hasConfirmed) {
                e.preventDefault();
                $('#modalConfirmMessage').modal('open');
                $('#modalConfirmMessage .messageBody div').text(
                    $('[name="timeline_message[message]"]').val()
                );
            }
        });
    }

    $('[data-preview-confirm]').on('click', function (e) {
        hasConfirmed = true;
        $('#timeLineMessage').submit();
    });

    $('[data-preview-edit]').on('click', function (e) {
        $('#timeLineMessage').find('.loadIcon').hide();
    });

    $('#timelineSegment').on("click", '.happy', function (e) {
        var action = 'add';
        if ($(this).hasClass('happied')) {
            action = 'remove'
        }
        var button = $(this);

        if (action === 'remove') {
            button.removeClass('happied');
        } else {
            button.addClass('happied');
        }
        var that = this;
        $.ajax({
            type: "POST",
            url: Routing.generate('timeline_happy', { id: $(this).data("item"), action: action }),
        })
            .done(function (data) {
                if (data.success && typeof data.happies !== 'undefined' && typeof data.count !== 'undefined') {
                    var intCount = parseInt(data.count);
                    if (intCount > 1) {
                        var template = $('#timelineSegment').data("happy-message");
                        let firstHappy = data.happies.shift();
                        var renderedTemplate = template.replace('%fullname%', firstHappy).replace('%totalHappies%', (intCount - 1)).replace('%happyPeople%', data.happies.join(', '));
                        $(that).siblings('.happies').html(renderedTemplate);
                    } else if (intCount === 1) {
                        var singleTemplate = $('#timelineSegment').data("single-happy-message");
                        $(that).siblings('.happies').html(singleTemplate.replace('%fullname%', data.happies[0]));
                    } else {
                        $(that).siblings('.happies').html('');
                    }
                }

            });

    });
    initMoreLess();

    $("#timeline_message_important").change(function () {
        if (this.checked) {
            $("p.alert").not(".app-preview").hide();
            $(".app-preview").show();
        } else {
            $("p.alert.app-preview").hide();
            $(".app-preview").hide();
        }
    });

    if( $(".app-preview").length > 0 ) {
        $("#timeline_message_message").keyup(function () {
            let string = $(this).val().trim();
            if (string.length > 70) {
                string = string.substr(0, 70) + '...'
            }
            $(".app-preview p").html(string);
        });
    }

    let isLoading = false;
    $('#messageBoard').on("click", ".additionalResponses", (event) => {
        event.preventDefault();
        if (isLoading || event.target.href === '#') return;
        isLoading = true;
        $.ajax({
            type: 'GET',
            url: event.target.href,
            contentType: 'application/json'
        }).done((data) => {
            if (data.nextLink === null) {
                $(event.target).hide();
            } else {
                event.target.href = data.nextLink;
            }
            const id = event.target.getAttribute('data-message-id');
            const $responses = $('#responses_' + id);
            const oldLength = $responses.children().length;
            $responses.append(data.html);
            const newTotalReplies = $responses.children();
            newTotalReplies.slice(oldLength - newTotalReplies.length).each(function () {
                handleReplyMessageChange($(this));
            });
            $('.timelineImage').materialbox();
            $('.singleImage').materialbox();
            isLoading = false;
        });
    })
});

var loadingReply = false;
function addReplySubmitFunction() {
    $('[id*=replyForm_]').submit(function (e) {
        e.preventDefault();
        if (loadingReply === false) {
            loadingReply = true;
            var id = $(this).parents('[id*="reply_"]').data('messageid');
            var replyForm = new FormData(this);
            $.ajax({
                type: "POST",
                url: Routing.generate('timeline_reply', { target: id }),
                data: replyForm,
                processData: false,
                contentType: false
            }).done(function (data) {
                if (data.success) {
                    const $responses = $('#responses_' + id);
                    $responses.prepend(data.form);
                    $('#replyForm_' + id + ' textarea').val('');
                    $('#replyForm_' + id + ' input[type="file"]').val('');
                    $('#replyForm_' + id + ' .file-path').val('');
                    $('#replyForm_' + id + ' .mediaUploadSection').hide();
                    $('#reply_' + id + ' .formContainer ul').remove();
                    $('.timelineImage').materialbox();
                    handleReplyMessageChange($responses.children().first());
                } else {
                    $('#reply_' + id + ' .formContainer').replaceWith(data.form);
                    $('#reply_' + id).find(".sendButton").addClass('active');
                    $('#reply_' + id).find(".menuIcon").addClass('active');
                    $('#reply_' + id).find(".input-field").addClass('active');
                    $('#reply_' + id).find(".replyButtons").addClass('active');
                    $('#replyForm_' + id + ' .mediaUploadSection').show();
                    addReplySubmitFunction(id);
                }
                $('#reply_' + id + ' .replyButtons .loadIcon').hide();
                loadingReply = false;
            }).fail(function (data) {
                $('#replyForm_' + id + ' button[type="submit"').attr('disabled', 'disabled');
                $('#error_replyForm_' + id).show();
                $('#reply_' + id + ' .replyButtons .loadIcon').hide();
                loadingReply = false;
            });
        }
    });
}

function handleReplyMessageChange($message) {
    $('.timelineImage').materialbox();
    initMoreLess();
    const $form = $message.find('.formContainer form');
    $form.submit(handleReplySubmit);
    $message.find('.btn-delete-image').click(openDeleteModal)
    $message.find('.btn-toggle-form').click(handleToggleResponseForm);
}

function handleMessageSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (loadingEditMessage === false) {
        loadingEditMessage = true;
        var id = $(e.target).parents('[id*="message_"]').data('messageid');
        var editForm = new FormData(this);
        $(e.target).find('.saveButton .loadIcon').show();
        $.ajax({
            type: "POST",
            url: Routing.generate('timeline_message_edit', { target: id }),
            data: editForm,
            processData: false,
            contentType: false
        }).done(function (data) {
            const $message = $(e.target).closest('.message');
            $message.find('> .messageBody').replaceWith(data.content);
            $message.find('> .images').replaceWith(data.images);
            $message.find('> .messageHeader .btn-toggle-form').addClass('icon-bewerken3')
            $message.find('> .messageHeader .btn-toggle-form').removeClass('icon-delete')
            $('.timelineImage').materialbox();
            $('.singleImage').materialbox();
            initMoreLess();
            const $form = $message.find('.formContainer form');
            addReplySubmitFunction();
            $form.submit(handleMessageSubmit);
            $message.find('.btn-delete-image').click(openDeleteModal)
            loadingEditMessage = false;
            $('#error_replyForm_' + id).hide();
            $(e.target).find('.saveButton .loadIcon').hide();
            loadingEditMessage = false;
        }).fail(function (data) {
            $('#error_replyForm_' + id).show();
            $(e.target).find('.saveButton .loadIcon').hide();
            loadingEditMessage = false;
        });
    }
}

function handleReplySubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (loadingEditMessage === false) {
        loadingEditMessage = true;
        var id = $(e.target).parents('[id*="response_"]').data('messageid');
        var editForm = new FormData(this);
        $(e.target).find('.saveButton .loadIcon').show();
        $.ajax({
            type: "POST",
            url: Routing.generate('timeline_message_edit', { target: id }),
            data: editForm,
            processData: false,
            contentType: false
        }).done(function (data) {
            $(e.target).closest('.messageHeader').replaceWith(data);
            handleReplyMessageChange($('#response_'+id));
            $(e.target).parent().find('.error').hide()
            loadingEditMessage = false;
        }).fail(function (data) {
            $(e.target).parent().find('.error').show()
            $(e.target).find('.saveButton .loadIcon').hide();
            loadingEditMessage = false;
        });
    }
}

function handleToggleMainForm(e) {
    const $target = $(e.target);
    const $message = $target.closest('.message');
    $message.find('.messageBody > *').toggleClass('hide');
    $message.find('> .images .btn-delete-image').toggleClass('hide');
    $target.toggleClass('icon-bewerken3 icon-delete');
    $message.find('> .messageBody .formContainer textarea').focus().select();
}

function handleToggleResponseForm(e) {
    const $target = $(e.target);
    const $reply = $target.closest('.messageHeader');
    $reply.find('.formContainer').toggleClass('hide');
    $reply.find('.message-data').toggleClass('hide');
    $reply.find('.btn-delete-image').toggleClass('hide');
    $target.children().toggleClass('icon-bewerken3 icon-delete')
    $reply.find('.formContainer textarea').focus().select();
    $reply.find('.mediaUploadSection .input-field .file-field .file-path-wrapper .file-path').on('change', function (e) {
        const $form = $reply.find('.formContainer form');
        $form.toggleClass('hasImages', e.target.value !== '');
    })
}

var selectedMessage;
var selectedMedia;

function openDeleteModal(e) {
    e.stopPropagation();
    $('#modalConfirmDeleteImage').modal('open');
    selectedMessage = $(e.target).data('msg-id');
    selectedMedia = $(e.target).data('img-id');
}
function openMessageReportModal(e) {
    e.stopPropagation();
    e.preventDefault();
    $('#modalReportMessage').modal('open');
    selectedMessage = $(e.target).data('msg-id');
}

var loadingEditMessage = false;
function addMessageEditFunction() {
    $('[id*=editMessageForm_]').off('submit').on('submit', handleMessageSubmit);
    $('[id*=editReplyForm_]').off('submit').on('submit', handleReplySubmit);

    $('#messageBoard .message > .messageHeader > .btn-toggle-form').off('click').on('click', handleToggleMainForm);
    $('#messageBoard .responses .btn-toggle-form').off('click').on('click', handleToggleResponseForm);
    $('.btn-delete-image').off('click').on('click', openDeleteModal);
}

function addReportMessageFunction() {
    $('.btn-report-message').off('click').on('click', openMessageReportModal);
}

function addDeleteImageConfirmationModalFunction() {
    $('#modalConfirmDeleteImage .modal-footer .confirm').click(function (e) {
        $('.btn-delete-image[data-img-id='+selectedMedia+']').hide();
        $.ajax({
            type: "POST",
            url: Routing.generate('timeline_media_delete', { target: selectedMessage, mediaId: selectedMedia }),
            data: null,
            processData: false,
            contentType: false
        }).done(function (data) {
            const images = $('.images[data-msg-id="'+selectedMessage+'"]');
            images.replaceWith(data);
            $('.timelineImage').materialbox();
            $('.singleImage').materialbox();
            const newImages = $('.images[data-msg-id="'+selectedMessage+'"]');
            newImages.find('.btn-delete-image').click(openDeleteModal);
            let formToggleBtn;
            if (newImages.parent().hasClass('message')) {
                formToggleBtn = newImages.closest('.message').find('.messageHeader .btn-toggle-form');
            } else { // handle reply
                formToggleBtn = newImages.closest('.messageHeader').find('.btn-toggle-form i');
            }
            if (formToggleBtn.hasClass('icon-delete')) {
                newImages.find('.btn-delete-image').toggleClass('hide');
            }
            loadingEditMessage = false;
        }).always(function (data) {
            $(e.target).find('.saveButton .loadIcon').hide();
            loadingEditMessage = false;
        });
    });
}
function addReportMessageConfirmationModalFunction() {
    console.log('registered modal confirm listener');
    $('#modalReportMessage .modal-footer .confirm').click(function (e) {
        $.ajax({
            type: "POST",
            url: Routing.generate('timeline_report_message', { target: selectedMessage }),
            data: null,
            processData: false,
            contentType: false
        });
    });
}

function initMoreLess() {
    var readMoreLess = $('#timeline [data-mrc]:not(".mrc")');
    readMoreLess.moreContent({
        speed: 800,
        shadow: true,
        height: 105,
        textClose: $('#timeline').data("close-message"),
        textOpen: $('#timeline').data("open-message"),
        tpl: {
            btn: '<span class="mrc-btn readMoreLess"></span>'
        }
    });
}
